import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendUrl = config.backendUrl

export const reassignSalesToManager = createAsyncThunk(
  "reassign/reassignSalesToManager",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BackendUrl}/reassigned`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to reassign sales to manager"
      );
    }
  }
);

const reassignSalesTomanagerSlice = createSlice({
  name: "reassignSalesTomanager",
  initialState: {
    loading: false,
    success: false,
    error: null,
    responseData: null,
  },
  reducers: {
    resetReassignState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.responseData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(reassignSalesToManager.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(reassignSalesToManager.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.responseData = action.payload;
      })
      .addCase(reassignSalesToManager.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetReassignState } = reassignSalesTomanagerSlice.actions;
export default reassignSalesTomanagerSlice.reducer;
